'use client';
import { css, styled } from '@mui/material/styles';
export const AlertIconBox = styled('div')(({ theme }) => css `
    flex: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    margin-right: ${theme.tokens.FuelSpacing3};
    height: ${theme.tokens.FuelLineHeightMd};
    width: ${theme.tokens.FuelLineHeightMd};
`);
